import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "../i18n";
import { IMAGES, LINKS, trackEvent } from "../data";

const EASE = [0.22, 1, 0.36, 1];

export default function FinalCTA({ onValuation }) {
  const { t } = useLanguage();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} data-testid="final-cta-section" className="relative overflow-hidden py-32 sm:py-44 lg:py-56">
      <motion.div style={{ y: bgY }} className="absolute -inset-y-[15%] inset-x-0">
        <img src={IMAGES.landscape} alt="Paesaggio dell'Ogliastra" loading="lazy" className="h-full w-full object-cover" />
      </motion.div>
      <div className="absolute inset-0 bg-navy/70" />
      <div className="absolute inset-0 bg-gradient-to-t from-navy via-transparent to-navy/60" />

      <div className="relative z-10 mx-auto max-w-4xl px-5 text-center sm:px-8">
        <motion.h2
          data-testid="final-cta-title"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-120px" }}
          transition={{ duration: 1, ease: EASE }}
          className="font-display text-4xl font-semibold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-7xl"
        >
          {t.finalCta.title}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-120px" }}
          transition={{ duration: 1, delay: 0.15, ease: EASE }}
          className="mx-auto mt-7 max-w-xl text-base leading-relaxed text-white/80 sm:text-lg"
        >
          {t.finalCta.sub}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-120px" }}
          transition={{ duration: 1, delay: 0.3, ease: EASE }}
          className="mt-11 flex flex-wrap items-center justify-center gap-4"
        >
          <button
            data-testid="final-cta-primary"
            onClick={() => {
              trackEvent("booking_click", { source: "final_cta" });
              window.location.assign(LINKS.booking);
            }}
            className="btn-primary"
          >
            {t.finalCta.ctaPrimary}
            <ArrowRight className="h-4 w-4" />
          </button>
          <button data-testid="final-cta-secondary" onClick={onValuation} className="btn-secondary">
            {t.finalCta.ctaSecondary}
          </button>
        </motion.div>
      </div>
    </section>
  );
}
